module.exports = __webpack_public_path__ + "media/images/common/list_ore_s-97bd5ef0d9b38ab40b5b4315300d26e4.gif";